module.exports = __webpack_public_path__ + "static/media/cq_calcola.7a40b000.svg";